import { createSelector } from 'reselect';

const selectMarketings = (state: any) => state.marketings;


export const selectMarketingsCurrentItem = createSelector([selectMarketings], (marketings) => marketings.current);

export const selectMarketingsListItems = createSelector([selectMarketings], (marketings) => marketings.list);

export const selectMarketingsItemById = (itemId: any) =>
    createSelector(selectMarketingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectMarketingsQueryItems = createSelector([selectMarketings], (marketings) => marketings.query);

export const selectMarketingsCreatedItem = createSelector([selectMarketings], (marketings) => marketings.create);

export const selectMarketingsUpdatedItem = createSelector([selectMarketings], (marketings) => marketings.update);

export const selectMarketingsReadItem = createSelector([selectMarketings], (marketings) => marketings.read);

export const selectMarketingsDeletedItem = createSelector([selectMarketings], (marketings) => marketings.delete);

export const selectMarketingsSearchedItems = createSelector([selectMarketings], (marketings) => marketings.search);

export const selectMarketingsItemsCount = createSelector([selectMarketings], (marketings) => marketings.count);

export const selectMarketingsItemsFilter = createSelector([selectMarketings], (marketings) => marketings.filter);

export const selectMarketingsSummaryItems = createSelector([selectMarketings], (marketings) => marketings.summary);